import { Navigate,useLocation } from "react-router-dom";
import TopHeader from "./Components/TopHeader";
export default function PrivateRoute({ element }) {
    const location = useLocation();
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1];
    }
    const id = obj["id"];
    const type = obj["type"];
    return sessionStorage.getItem("Admintoken") ? (
        <div className="page-container">
            {location.pathname == "/chartbotwithkbintent" || (location.pathname == "/chartbotintent" && type == "BASIC_WITHOUT_KB" ) ? "" : <TopHeader />  }
            <div className={`page-content ${location.pathname == "/chartbotwithkbintent" || (location.pathname == "/chartbotintent" && type == "BASIC_WITHOUT_KB" ) ? "intentActive" : "" }`}>
                {element} 
            </div>
        </div>

    ) : (
        <Navigate to="/login" />
    );
}

